import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/features/auth/components/profile-page";

/**
 * Your own profile. No permission gate, like Change password: `_app` already requires a session, and
 * the page shows nobody but the person signed in.
 */
export const Route = createFileRoute("/_app/account/profile")({
  component: ProfilePage,
});
